import { Route, Routes, Navigate } from "react-router-dom";
import AuthRedirect from "@ui/pages/AuthRedirect";
import React from "react";
import Layout from "./Layout";
import ProtectedRoute from "../../auth/ProtectedRoute";
import UnAuthorizedPage from "@ui/pages/unauthorized-page";
import { Home } from "@ui/pages/project";
import { ProjectDetails } from "@ui/pages/project-detail";
import { ForecastAdjustPage } from "@ui/pages/project-detail/ForecastAdjustPage";
import { LoginPage } from "@ui/pages/auth/LoginPage";
import { Users } from "@ui/pages/users";
import RolePermissions from "@ui/pages/role-permission";
import RolePermissionsDetail from "@ui/pages/role-permission/role-permission-detail";
import { Settings } from "@ui/pages/settings";
const AppRoutes = () => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "/", element: React.createElement(Navigate, { to: "/project", replace: true }) }),
        React.createElement(Route, { path: "*", element: React.createElement(UnAuthorizedPage, { message: "Page not found" }) }),
        React.createElement(Route, { path: "login", element: React.createElement(LoginPage, null) }),
        React.createElement(Route, { path: "forbidden", element: React.createElement(UnAuthorizedPage, { message: "You do not have access here" }) }),
        React.createElement(Route, { path: "unauthorized", element: React.createElement(UnAuthorizedPage, { message: "Please login to access this page" }) }),
        React.createElement(Route, { path: "session", element: React.createElement(UnAuthorizedPage, { sessionTimeout: true, message: "Please login to access this page" }) }),
        React.createElement(Route, { element: React.createElement(ProtectedRoute, null,
                React.createElement(Layout, null)) },
            React.createElement(Route, { path: "project" },
                React.createElement(Route, { index: true, element: React.createElement(Home, null) }),
                React.createElement(Route, { path: ":projectId/details", element: React.createElement(ProjectDetails, null) }),
                React.createElement(Route, { path: ":projectId/details/forecast", element: React.createElement(ForecastAdjustPage, null) })),
            React.createElement(Route, { path: "users", element: React.createElement(Users, null) }),
            React.createElement(Route, { path: "roles-permissions" },
                React.createElement(Route, { index: true, element: React.createElement(RolePermissions, null) }),
                React.createElement(Route, { path: ":roleId/details", element: React.createElement(RolePermissionsDetail, null) })),
            React.createElement(Route, { path: "settings", element: React.createElement(Settings, null) })),
        React.createElement(Route, { path: "/ms-redirect", element: React.createElement(AuthRedirect, null) })));
};
export default AppRoutes;
